<mat-toolbar>
  <div class="fs-row.align-center mobile">
    <a fsNavBack><mat-icon class="back-icon">keyboard_arrow_left</mat-icon></a>
    <button
      mat-icon-button
      class="mobile-menu"
      (click)="sideNavClick()">
      <mat-icon>menu</mat-icon>
      @if (unreadCount()) {
        <div
            class="count"
            [attr.data-count]="unreadCount()">
          {{ unreadCount() }}
        </div>
      }
    </button>
    <div fsNavComponent="image" type="image"></div>
    <div>
      <div fsNavSupertitle></div>
      <div fsNavTitle></div>
    </div>
  </div>

  <div class="banner hide-sm">
    @if (bannerActive()) {
      <button
        mat-button
        type="button"
        class="banner-toggle-text"
        (click)="toggleBanner()"
        [attr.aria-label]="bannerToggleLabel">
        {{ bannerToggleLabel }}
      </button>
    }
    <div class="banner-content" [class.collapsed]="bannerCollapsed()">
      <fs-banner [type]="bannerType"></fs-banner>
    </div>
  </div>

  <div id="buttons">
    @if (showAppCallOut) {
      <button
        mat-mini-fab
        (click)="openAppCallOut()"
        class="hide-sm"
        [class.accent]="!appCallOutColor"
        [style.background-color]="appCallOutColor || null"
        [matTooltip]="appCallOutTitle">
        <mat-icon class="material-symbols-outlined-filled">
          release_alert
        </mat-icon>
      </button>
    }
  
    <button
        mat-mini-fab
        class="hide-sm">
      <mat-icon
          (click)="support()"
          class="material-symbols-outlined-filled">
        contact_support
      </mat-icon>
    </button>
  
    @if (account) {
      <button
        mat-icon-button
        class="icon-image"
        data-testid="accountIcon"
        [matMenuTriggerFor]="!isMobile ? menu : null"
        (click)="openMenu()">
        <img [src]="account.avatar?.small">
        <mat-icon class="account-mobile">arrow_drop_down</mat-icon>
      </button>
      <mat-menu
        #menu="matMenu"
        class="account-menu">
        @if (isSmallView) {
          <a
            mat-menu-item
            class="main-item"
            (click)="support()">
            Help
          </a>
          @if (showAppCallOut) {
            <a
              mat-menu-item
              class="main-item"
              (click)="openAppCallOut()">
              {{ appCallOutTitle ? appCallOutTitle : 'Information'}}
            </a>
          }
        }
        <a
          mat-menu-item
          class="main-item"
          [routerLink]="accountPath">
          Account settings
        </a>
        @if (!isParentExperience) {
          @if (adminMenuItems.length > 0) {
            <div class="menu-section">
              Admin
            </div>
            @for (adminMenuItem of adminMenuItems; track adminMenuItem.label) {
              <a
                mat-menu-item
                [routerLink]="adminMenuItem.path">
                {{ adminMenuItem.label }}
              </a>
            }
          }
          @if (systemMenuItems.length > 0) {
            <div class="menu-section">
              System
            </div>
            @for (systemMenuItem of systemMenuItems; track systemMenuItem.label) {
              <a
                mat-menu-item
                [routerLink]="systemMenuItem.path">
                {{ systemMenuItem.label }}
              </a>
            }
          }
        }
        <button
            mat-menu-item
            class="main-item"
            (click)="signOut()">
          Sign out
        </button>
      </mat-menu>
    }
  </div>

</mat-toolbar>
<div class="banner show-sm" [class.has-toggle]="bannerActive()">
  @if (bannerActive()) {
    <button
      mat-button
      type="button"
      class="banner-toggle-text"
      (click)="toggleBanner()"
      [attr.aria-label]="bannerToggleLabel">
      {{ bannerToggleLabel }}
    </button>
  }
  <div class="banner-content" [class.collapsed]="bannerCollapsed()">
    <fs-banner [type]="bannerType"></fs-banner>
  </div>
</div>
